import { IInscricao } from "shared/features/api/inscricao/types";
import { PainelEtapaBase } from "../PainelAvaliacaoBase";
import { useAvaliarPreRequisitosTodasInscricoesMutation } from "shared/features/api/avaliacao/avaliacaoSlice";
import { Etapa } from "shared/features/api/edicao/edicaoSlice";

interface AvaliacaoPreRequisitosProps {
  etapa: Etapa;
  inscricoes: IInscricao;
  setSearch: (value: string) => void;
  page: number;
  setPage: (page: number) => void;
  statusEtapa: string;
  setStatusEtapa: (valor: string) => void;
  trilha: string;
  setTrilha: (valor: string) => void;
}

export const AvaliacaoPreRequisitos: React.FC<AvaliacaoPreRequisitosProps> = ({
  etapa,
  inscricoes,
  setSearch,
  page,
  setPage,
  statusEtapa,
  setStatusEtapa,
  trilha,
  setTrilha,
}) => {
  const [avaliarTodas, { isLoading }] =
    useAvaliarPreRequisitosTodasInscricoesMutation();

  const handleAvaliarTodas = async () => {
    await avaliarTodas();
  };

  return (
    <PainelEtapaBase
      etapa={etapa}
      inscricoes={inscricoes}
      avaliarTodas={handleAvaliarTodas}
      isLoading={isLoading}
      setSearch={setSearch}
      page={page}
      setPage={setPage}
      setStatusEtapa={setStatusEtapa}
      statusEtapa={statusEtapa}
      trilha={trilha}
      setTrilha={setTrilha}
    />
  );
};
